export default {
  inviteFriendReport: {
    total: "Total",
    depth: { root: "Amigo Principal", level: "Amigo de Nivel {{level}}" },
    scope: { root: "Línea Completa", inviter: "Amigos Directos (1 Nivel)", member: "Propio" },
    scopeDirect: "Datos directos",
    rowType: { context: "Amigo principal de esta cadena (fila de contexto)", hit: "Usuario coincidente" },
    filter: {
      account: "Cuenta",
      tag: "Etiqueta de Usuario",
      tagPlaceholder: "p. ej. Promotor",
      currency: "Moneda",
      range: "Rango de Fechas",
      agent: "Agente",
      agentAll: "Todos",
      agentUnassigned: "Sin asignar"
    },
    column: {
      member: "Usuario",
      scope: "Nivel / Alcance",
      agentAccount: "Agente",
      date: "Fecha",
      inviteMemberCount: "Miembros Invitados",
      directInviteCount: "Invitados Directos",
      firstDepositMemberCount: "Miembros con Primer Depósito",
      firstDepositAmount: "Monto Primer Depósito",
      depositTimes: "Veces de Depósito",
      depositAmount: "Monto de Depósito",
      withdrawTimes: "Veces de Retiro",
      withdrawAmount: "Monto de Retiro",
      validBetAmount: "Apuesta Válida",
      ggrAmount: "GGR",
      bonusAmount: "Bono Recibido (incl. Comisión)",
      commissionAmount: "de los cuales: Comisión de Invitación",
      pointExchangeCash: "Puntos Canjeados a Efectivo",
      directFriend: "Amigo Directo",
      selfDepositAmount: "Depósito Propio",
      selfWithdrawAmount: "Retiro Propio",
      selfValidBetAmount: "Apuesta Válida Propia",
      selfGgrAmount: "GGR Propio",
      selfBonusAmount: "Bono Propio Recibido (incl. Comisión)",
      selfCommissionAmount: "Comisión de Invitación Propia",
      selfPointExchangeCash: "Puntos Canjeados Propios",
      trendInviteMember: "Usuarios Invitados",
      trendFirstDepositMember: "Invitados con Primer Depósito",
      action: "Acción"
    },
    action: { view: "Ver" },
    breadcrumb: { back: "Volver a la lista", list: "Lista Resumen" },
    composition: { rest: "Subtotal de Niveles Inferiores (nivel 2+, sin detallar)", total: "Total (= Línea Completa = Indicadores)" },
    analysis: {
      title: "Análisis de Invitación de {{account}}",
      directFriends: "Amigos Directos (fila = datos propios del amigo)",
      trendTitle: "Tendencia Diaria ({{scope}})",
      trendHint: "Mostrado por día; el rango de fechas sigue el filtro superior; la fila de total es el total del rango (para un total semanal / mensual, ajuste el rango a esa semana / mes).",
      inviterScopeHint: "No incluye los datos propios de este miembro"
    },
    tip: {
      needCurrencyAndRange: "Seleccione primero la moneda y el rango de fechas",
      searchMixed: "Se encontró un usuario no principal: la fila superior es el amigo principal de la cadena (línea completa) y la inferior son los datos directos de ese usuario. Ambos alcances no se pueden sumar, por lo que el total está oculto."
    }
  },

  comprehensiveReport: {
    title: "Panel de Control",
    profit: "Ganancia",
    profitRate: "Tasa de Ganancia",
    totalBet: "Apuesta Total",
    validBet: "Apuesta Válida",
    betUsers: "Usuarios Apostadores",
    onlineUsers: "Usuarios en Línea",
    onlineUsersTooltip: "Usuarios en línea en tiempo real, no afectados por filtros",
    gameProfitLoss: "Ganancia/Pérdida de Juegos",
    memberBalance: "Saldo del Miembro",
    deposit: "Depósito",
    totalDeposit: "Depósito Total",
    withdrawal: "Retiro",
    totalWithdrawal: "Retiro Total",
    userStatistics: "Estadísticas de Usuarios",
    bettingStatistics: "Estadísticas de Apuestas",
    bettingOrders: "Órdenes de Apuestas",
    monthlyComparison: "Comparación Mensual",
    thisMonthProfit: "Ganancia de Este Mes",
    thisMonthProfitRate: "Tasa de Ganancia de Este Mes",
    lastMonthProfit: "Ganancia del Mes Pasado",
    lastMonthProfitRate: "Tasa de Ganancia del Mes Pasado",
    registeredUsers: "Usuarios Registrados",
    firstDepositUsers: "Usuarios del Primer Depósito",
    secondDepositUsers: "Usuarios del Segundo Depósito",
    thirdDepositUsers: "Usuarios del Tercer Depósito",
    memberCount: "Cantidad de Miembros",
    users: "Usuarios",
    depositTransactions: "Transacciones de Depósito",
    withdrawalTransactions: "Transacciones de Retiro",
    manualWithdrawal: "Retiro Manual",
    countedWithdrawal: "Retiro Contabilizado",
    uncountedWithdrawal: "Retiro No Contabilizado",
    rejectedWithdrawal: "Retiro Rechazado",
    totalPromo: "Promociones Totales",
    paymentMethods: {
      bankCard: "Tarjeta Bancaria",
      gcash: "GCash",
      paymaya: "PAYmaya",
      manualDeposit: "Depósito Manual",
      countedDeposit: "Depósito Contabilizado",
      uncountedDeposit: "Depósito No Contabilizado",
      promo1: "Bono de Promoción",
      promo2: "Bono VIP",
      promo3: "Promo 3"
    },
    withdrawalMethods: {
      bankCard: "Tarjeta Bancaria",
      gcash: "GCash",
      paymaya: "PAYmaya"
    },
    vipWeeklySalary: "Salario VIP Semanal",
    vipMonthlySalary: "Salario VIP Mensual",
    vipBirthdayBonus: "Bono de Cumpleaños VIP",
    vipUpgradePoints: "Puntos de Actualización VIP",
    vipRetentionPoints: "Puntos de Retención VIP",
    vipAppDailyPoints: "Puntos Diarios de la Aplicación VIP",
    vipH5DailyPoints: "Puntos Diarios H5 VIP",
    vipUpgradeBonus: "Bono de Actualización VIP",
    vipRetentionBonus: "Bono de Retención VIP",
    actManualBonus: "Bono de Promoción Manual",
    actRealtimeRebateBonus: "Bono de Devolución de Juego VIP",
    actRegisterBonus: "Bono de Registro",
    actRebateBonus: "Bono de Devolución",
    detail: "Detalles",
    amount: "Monto",
    search: "Buscar",
    reset: "Restablecer",
    today: "Hoy",
    yesterday: "Ayer",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Finalización",
    Manual: "Manual",
    Bank: "Banco",
    registerCount: "Cantidad de Registros",
    depositCount: "Cantidad de Depósitos",
    withdrawCount: "Cantidad de Retiros",
    betCount: "Cantidad de Apuestas",
    firstDepositCount: "Cantidad del Primer Depósito",
    chart: "Gráfico",
    table: "Tabla",
    noData: "Sin Datos",
    day: "Fecha",
    dataTip: "Nota: (Las estadísticas del día actual pueden retrasarse una hora. Para otros días, los datos se capturan diariamente a las 23:59:59)",
    dateRangeExceeded: "El rango de fechas personalizado no puede exceder 31 días",
    pointExchange: "Canje de Puntos",
    cashExchange: "Canje de Efectivo",
    physicalExchange: "Canje de Bienes Físicos",
    toolExchange: "Canje de Artículos Virtuales",
    exchangeMemberCount: "Miembros",
    exchangeQuantity: "Cantidad",
    exchangeAmount: "Monto",
    exchangeTotal: "Total",
    adjustIncrease: "Ajuste de Crédito: Aumento",
    adjustDecrease: "Ajuste de Crédito: Disminución",
    backendToAgentAdjust: "Ajuste de Cuenta Backend a Agente",
    agentAdjust: "Ajuste de Agente",
    adjustTransactions: "Transacciones de Asignación"
  },
  regionChoropleth: {
    panelTitle: "Distribución Regional ({country})",
    panelHint: "Haga clic en una región para localizarla en el mapa",
    legendTitle: "Leyenda (Usuarios)",
    countries: {
      PH: "Regiones de Filipinas",
      VN: "Regiones de Vietnam",
    },
  },
  activeUserDistribution: {
    title: "Panel de Usuarios Activos",
    filters: {
      timeRange: "Rango de Tiempo",
      timeRangeRequired: "Por favor seleccione rango de tiempo",
      currency: "Moneda",
      currencyRequired: "Por favor seleccione moneda",
      currencyPlaceholder: "Seleccionar moneda",
      countryAll: "Todos",
    },
    actions: {
      search: "Buscar",
      reset: "Restablecer",
    },
    cards: {
      dailyTrend: "Tendencia de Usuarios Activos",
      agentDistribution: "Distribución de Agentes de Usuarios Activos",
      deviceDistribution: "Distribución de Dispositivos de Usuarios Activos",
      mobileProviderDistribution: "Distribución de Proveedores Móviles de Usuarios Activos",
      depositDistribution: "Distribución de Depósitos de Usuarios Activos",
      regionDistribution: "Distribución Regional",
    },
    regionTable: {
      country: "País",
      province: "Provincia",
      city: "Ciudad",
      total: "Usuarios",
    },
    labels: {
      activeUserCount: "Usuarios Activos",
      noData: "Sin datos",
      noRegionData: "Sin datos regionales",
      noCityData: "Sin datos de ciudad",
      total: "Total de Usuarios Activos",
      unknown: "Desconocido",
      agentUnknown: "Tipo de Agente {id}",
    },
    agentTypes: {
      official: "Sitio Web Oficial",
      agent: "Agente",
      adEntry: "Entrada de Anuncio",
      activity: "Actividad",
    },
    devices: {
      all: "Todos",
      androidApp: "Aplicación Android",
      androidPwa: "PWA Android",
      androidH5: "Android H5",
      iosApp: "Aplicación iOS",
      iosPwa: "PWA iOS",
      iosH5: "iOS H5",
      web: "Web",
      others: "Otros",
    },
    mobileProviders: {
      smart: "Smart",
      globe: "Globe",
      dito: "DITO",
    },
    depositStatus: {
      firstDeposit: "Primer Depósito",
      repeatDeposit: "Depósito Repetido",
      noDeposit: "Sin Depósito",
    },
    regionMap: {
      title: "Distribución Regional (Mapa de Provincias de PH)",
      provinceMapLabel: "Mapa de Provincias",
      columns: {
        region: "Región",
        users: "Usuarios",
      },
      summary: {
        coverage: "{count} regiones reportando",
      },
    },
  },
  userRegisterDistribution: {
    title: "Panel de Registro de Usuarios",
    filters: {
      timeRange: "Tiempo de Registro",
      timeRangeRequired: "Por favor seleccione tiempo de registro",
      agentType: "Tipo de Agente",
      agentTypePlaceholder: "Seleccionar tipo de agente",
      loginChannel: "Canal de Inicio de Sesión",
      loginChannelPlaceholder: "Seleccionar canal de inicio de sesión",
      currency: "Moneda",
      currencyPlaceholder: "Seleccionar moneda",
      countryAll: "Todos",
      mobileProvider: "Operador Móvil",
      mobileProviderPlaceholder: "Seleccionar operador móvil",
      depositStatus: "Estado de Depósito",
      depositStatusPlaceholder: "Seleccionar estado de depósito"
    },
    actions: {
      search: "Buscar",
      reset: "Restablecer"
    },
    loginChannels: {
      all: "Todos",
      androidApp: "Aplicación Android",
      androidPwa: "PWA Android",
      androidH5: "Android H5",
      iosApp: "Aplicación iOS",
      iosPwa: "PWA iOS",
      iosH5: "iOS H5",
      web: "Web",
      others: "Otros"
    },
    depositStatus: {
      all: "Todos los Estados",
      firstDeposit: "Usuarios del Primer Depósito",
      repeatDeposit: "Usuarios del Depósito Repetido",
      noDeposit: "Usuarios sin Depósito"
    },
    cards: {
      dailyTrend: "Tendencia de Registro",
      registerSource: "Distribución de Fuente de Registro",
      loginChannel: "Distribución del Canal de Inicio de Sesión",
      depositStatus: "Distribución del Estado de Depósito",
      mobileProvider: "Distribución del Operador Móvil",
      regionDistribution: "Distribución Regional"
    },
    regionTable: {
      country: "País",
      province: "Provincia",
      city: "Ciudad",
      total: "Usuarios Registrados"
    },
    labels: {
      registerCount: "Registros",
      noData: "Sin datos",
      noRegionData: "Sin datos regionales",
      noCityData: "Sin datos de ciudad",
      total: "Total de Registros",
      unknown: "Desconocido",
      agentUnknown: "Tipo de Agente {id}"
    },
    agentFallback: "Tipo de Agente Desconocido",
    fetchAgentFailed: "Error al obtener la lista de tipos de agentes",
    regionMap: {
      "viewCities": "Ver Ciudades",
      title: "Mapa de Calor Regional",
      countryPlaceholder: "Seleccionar país",
      noData: "Sin datos de mapa",
      notSupported: "El mapa para este país no es compatible",
      loadFailed: "Error al cargar datos del mapa",
      loadFailedWithFallback: "No se puede descargar el mapa automáticamente. Por favor coloque un archivo GeoJSON en {fallback} o configure un espejo accesible.",
      accessDenied: "La solicitud de datos del mapa fue denegada. Por favor proxy la solicitud o use otra fuente de datos.",
      tooltipRegion: "Región",
      provinceMapLabel: "Mapa de Provincias",
      columns: {
        region: "Región",
        users: "Registros"
      },
      summary: {
        title: "Resumen de puntos críticos",
        total: "Total de registros",
        average: "Promedio / provincia",
        peak: "Región más crítica",
        low: "Región menos crítica",
        topRegions: "Regiones principales",
        coverage: "{count} provincias reportando"
      }
    }
  },
  betRecordReportList: {
    title: "Consulta de Registro de Apuestas",
    prompt: "(Además del filtro de tiempo, complete al menos una condición de búsqueda)",
    memberAccount: "Cuenta del Miembro",
    orderNumber: "Número de Orden",
    betNumber: "Número de Apuesta",
    betDetails: "Detalles de Apuesta",
    payoutAmount: "Monto del Pago",
    profitLossChange: "Cambio de Ganancia/Pérdida",
    betSlipStatus: "Estado del Comprobante de Apuesta",
    settlementVersion: "Versión de Liquidación",
    repeatSettlement: "Liquidación Repetida",
    transferBetSlip: "Transferir Comprobante de Apuesta",
    gameName: "Nombre del Juego",
    gameCode: "Código del Juego",
    actions: "Acciones",
    details: "Detalles",
    matchStartTime: "Hora de Inicio del Partido",
    isLive: "Es en Directo",
    leagueName: "Nombre de la Liga",
    betMarket: "Mercado de Apuestas",
    betOdds: "Cuotas de Apuesta",
    parlayType: "Tipo de Parlay",
    settled: "Liquidado",
    unsettled: "No Liquidado",
    yes: "Sí",
    no: "No",
    gameType: "Tipo de Juego",
    betTime: "Hora de Apuesta",
    settlementTime: "Hora de Liquidación",
    settlementTimeFilter: "Filtro de Hora de Liquidación",
    detailTitle: "Detalles de Apuesta Deportiva",
    basicInfo: "Información Básica",
    betContent: "Contenido de Apuesta",
    settlementHistory: "Historial de Liquidación",
    betSlipNumber: "Número de Comprobante de Apuesta",
    firstSettlementTime: "Hora de Primera Liquidación",
    lastSettlementTime: "Hora de Última Liquidación",
    memberProfitLoss: "Ganancia/Pérdida del Miembro",
    jackpotContribution: "Contribución al Jackpot",
    jackpotPayout: "Pago del Jackpot",
    eventName: "Nombre del Evento",
    finalScore: "Marcador Final",
    singleItemStatus: "Estado del Artículo Individual",
    settlementStatus: "Estado de Liquidación",
    settlementCurrency: "Moneda de Liquidación",
    profitLossAmount: "Monto de Ganancia/Pérdida",
    settlementReason: "Motivo de Liquidación",
    win: "Ganancia",
    lose: "Pérdida",
    halfWin: "Media Ganancia",
    halfLose: "Media Pérdida",
    push: "Empate",
    cancelled: "Cancelado",
    pendingSettlement: "Liquidación Pendiente",
    sportBetDetails: "Detalles de Apuesta Deportiva",
    timeFilter: "Filtro de Tiempo",
    dateRangeExceed32Days: "El rango de fechas no puede exceder 32 días",
    settleDateRangeExceed32Days: "El rango de fechas de liquidación no puede exceder 32 días",
    selectBetTime: "Por favor seleccione hora de apuesta",
    loadDataFailed: "No se pudo cargar los datos",
    collapse: "Contraer",
    expand: "Expandir",
    parlayCount: "{count} Parlay"
  },
  betRecordHourlyList: {
    title: "Informe de Registro de Apuestas",
    prompt: "Los datos del día anterior se procesan a las 4 AM",
    timeRange: "Rango de Tiempo",
    timeRangeRequired: "Por favor seleccione rango de tiempo",
    memberAccount: "Cuenta de Miembro",
    exportWarning: "Por favor ingrese criterios de búsqueda primero",
    notes: "Notas:",
    note1: "Los datos del día anterior se procesan a las 4 AM",
    note2: "Los datos de apuestas del día actual no pueden ser consultados",
    note3: "Admite visualización de datos paginados, los usuarios pueden seleccionar el número de entradas por página"
  },

  gamePlatformReport: {
    date: "Fecha",
    statisticsDate: "Fecha de Estadísticas",
    platformType: "Tipo de Plataforma",
    platformName: "Nombre de la Plataforma",
    platformKey: "Clave de Plataforma",
    currency: "Moneda",
    betUsers: "Usuarios que Apuestan",
    betOrders: "Órdenes de Apuesta",
    betAmount: "Monto de Apuesta",
    memberProfit: "Ganancia del Miembro",
    platformProfit: "Ganancia de la Plataforma",
    killRate: "Ventaja de la Casa",
    killRateTooltip: "Ganancia de la Plataforma / Monto de Apuesta",
    rtp: "RTP",
    rtpTooltip: "1 - Ventaja de la Casa",
    ggr: "GGR",
    ggrTooltip: "Monto de Apuesta - Pago",
    total: "Total",
    subGameName: "Nombre del Subjuego",
    enterPlatformName: "Ingrese Nombre de Plataforma",
    enterPlatformKey: "Ingrese Clave de Plataforma",
    enterSubGameName: "Ingrese Nombre del Subjuego",
    all: "Todos",
    today: "Hoy",
    yesterday: "Ayer",
    thisWeek: "Esta Semana",
    thisMonth: "Este Mes",
    lastMonth: "Mes Pasado",
    last7Days: "Últimos 7 Días",
    last30Days: "Últimos 30 Días",
    totalRecords: "Total {total} registros",
    search: "Buscar",
    reset: "Restablecer",
    noData: "Sin Datos",
  },
  gameCodeReport: {
    "date": "Fecha",
    "subGameName": "Nombre del Subjuego",
    "betNumber": "Número de Apuesta",
    title: "Informe de Subjuego",
    prompt: "Los datos del día anterior se procesan a las 4 AM",
    memberAccount: "Cuenta de Miembro",
    orderNumber: "Número de Orden",
    statisticsDate: "Fecha de Estadísticas",
    gameName: "Nombre del Juego",
    platformName: "Nombre de la Plataforma",
    platformKey: "Clave de Plataforma",
    currency: "Moneda",
    betUsers: "Usuarios que Apuestan",
    betOrders: "Órdenes de Apuesta",
    betAmount: "Monto de Apuesta",
    memberProfit: "Ganancia del Miembro",
    platformProfit: "Ganancia de la Plataforma",
    killRate: "Ventaja de la Casa",
    killRateTooltip: "Ganancia de la Plataforma / Monto de Apuesta",
    rtp: "RTP",
    rtpTooltip: "1 - Ventaja de la Casa",
    ggr: "GGR",
    ggrTooltip: "Monto de Apuesta - Pago",
    total: "Total",
    enterGameName: "Ingrese Nombre del Juego",
    enterPlatformName: "Ingrese Nombre de Plataforma",
    enterPlatformKey: "Ingrese Clave de Plataforma",
    enterSubGameName: "Ingrese Nombre del Subjuego",
    all: "Todos",
    today: "Hoy",
    yesterday: "Ayer",
    thisWeek: "Esta Semana",
    thisMonth: "Este Mes",
    lastMonth: "Mes Pasado",
    last7Days: "Últimos 7 Días",
    last30Days: "Últimos 30 Días",
    totalRecords: "Total {total} registros",
    search: "Buscar",
    reset: "Restablecer",
    noData: "Sin Datos",
  },
  depositReport: {
    title: "Informe de Depósitos",
    date: "Fecha de Depósito",
    currency: "Moneda",
    paymentChannel: "Canal de Pago",
    totalOrders: "Órdenes Totales",
    totalAmount: "Monto Total",
    totalSuccessOrders: "Órdenes Exitosas Totales",
    totalPaySuccessAmount: "Monto Total de Pago Exitoso",
    successRate: "Tasa de Éxito",
    thirdPartySuccessRate: "Tasa de Éxito de Terceros",
    depositDate: "Fecha de Depósito",
    selectPaymentChannel: "Por favor seleccione canal de pago",
    total: "Total",
    search: "Buscar",
    reset: "Restablecer",
    all: "Todos",
    totalRecords: "Total {total} registros",
    noData: "Sin Datos",
    dateRange: {
      today: "Hoy",
      yesterday: "Ayer",
      thisWeek: "Esta Semana",
      thisMonth: "Este Mes",
      lastMonth: "Mes Pasado",
      last7Days: "Últimos 7 Días",
      last30Days: "Últimos 30 Días"
    }
  },
  agentBonusStats: {
    title: "Informe de Bono de Agente",
    dateRange: "Rango de Fechas",
    dateRangeRequired: "Por favor seleccione un rango de fechas",
    dateRangeExceeds3Months: "El rango de fechas no puede exceder 3 meses",
    cannotQueryCurrentDay: "No se puede consultar datos del día actual",
    agentAccount: "Cuenta de Agente",
    agentAccountPlaceholder: "Por favor ingrese cuenta de agente",
    currency: "Moneda",
    currencyPlaceholder: "Por favor seleccione moneda",
    bonusName: "Nombre del Bono",
    bonusNamePlaceholder: "Por favor ingrese nombre del bono",
    bonusType: "Tipo de Bono",
    bonusTypePlaceholder: "Por favor seleccione tipo de bono",
    joinCount: "Participantes",
    bonusAmount: "Monto de Distribución",
    bonusPoint: "Puntos de Distribución",
    day: "Fecha",
    cashTab: "Efectivo",
    pointsTab: "Puntos",
    agentName: "Nombre del Agente",
    agentType: "Tipo de Agente",
    level1Agent: "Nivel 1",
    directAgent: "Directo",
    level2Agent: "Nivel 2",
    summary: "Resumen"
  },
  bonusRecordReport: {
    title: "Informe de Registro de Bono",
    prompt: "Consultar registros de distribución de bonos",
    dateRange: "Rango de Fechas",
    dateRangeRequired: "Por favor seleccione un rango de fechas",
    dateRangeExceedsLimit: "El rango de fechas no puede exceder 7 días",
    dateRangeExceeds3Months: "El rango de fechas no puede exceder 3 meses",
    dateRangeExceeds6Months: "El rango de fechas no puede exceder 6 meses",
    cannotQueryCurrentDay: "No se puede consultar datos del día actual",
    pleaseEnterMemberAccount: "Por favor ingrese cuenta de miembro",
    pleaseEnterSearchCriteria: "Por favor ingrese al menos un criterio de búsqueda",
    currency: "Moneda",
    currencyPlaceholder: "Seleccionar moneda",
    bonusName: "Nombre del Bono",
    bonusNamePlaceholder: "Ingrese nombre del bono",
    bonusType: "Tipo de Bono",
    bonusTypePlaceholder: "Seleccionar tipo de bono",
    "bonusType.monthlySalaryPoint": "Puntos de Salario Mensual",
    "bonusType.weeklySalaryPoint": "Puntos de Salario Semanal",
    "bonusType.birthdayPoint": "Puntos de Cumpleaños",
    joinCount: "Cantidad de Participantes",
    bonusAmount: "Monto del Bono",
    bonusPoint: "Puntos del Bono",
    day: "Fecha",
    cashTab: "Efectivo",
    pointsTab: "Puntos",
    status: "Estado",
    completed: "Completado",
    pending: "Pendiente",
    memberAccount: "Cuenta de Miembro",
    memberAccountPlaceholder: "Ingrese cuenta de miembro"
  },
  withdrawReport: {
    title: "Informe de Retiro",
    withdrawDate: "Fecha de Retiro",
    currency: "Moneda",
    withdrawChannel: "Canal de Retiro",
    withdrawModel: "Método de Retiro",
    serialNumber: "No.",
    totalWithdrawCount: "Cantidad Total de Retiros",
    totalWithdrawAmount: "Monto Total de Retiro",
    withdrawFee: "Tarifa de Retiro",
    successfulWithdrawCount: "Cantidad de Retiros Exitosos",
    successfulWithdrawAmount: "Monto de Retiro Exitoso",
    withdrawSuccessRate: "Tasa de Éxito de Retiro",
    manual: "Manual",
    all: "Todos",
    total: "Total",
    search: "Buscar",
    reset: "Restablecer",
    export: "Exportar",
    totalRecords: "Total {total} registros",
    dateRangeRequired: "Por favor seleccione rango de fechas",
    exporting: "Exportando, por favor espere...",
    exportSuccess: "Exportación exitosa",
    exportFailed: "Exportación fallida",
    today: "Hoy",
    yesterday: "Ayer",
    thisWeek: "Esta Semana",
    thisMonth: "Este Mes",
    lastMonth: "Mes Pasado",
    last7Days: "Últimos 7 Días",
    last30Days: "Últimos 30 Días"
  },
  registrationConversionReport: {
    "dateRangeExceeded": "El rango de fechas no puede exceder 31 días",
    title: "Informe de Registro y Conversión",
    dateRange: "Rango de Fechas",
    date: "Fecha",
    day: "Fecha",
    registerCount: "Usuarios Registrados",
    registerFirstDepositCount: "Registros de Primer Depósito",
    activeFirstDeposit: "Primeros Depósitos Activos",
    registerFirstDepositRate: "Tasa de Conversión de Primer Depósito",
    totalFirstDepositRate: "Tasa Total de Conversión de Primer Depósito",
    retentionCount: "Usuarios Retenidos",
    cumulativeDepositNumber: "Cantidad de Recargas Acumuladas",
    cumulativeDepositAmount: "Monto de Recargas Acumulado",
    search: "Consultar",
    reset: "Restablecer",
    export: "Exportar",
    noData: "Sin Datos",
    isAppUser: "Por favor seleccione si es usuario de APP",
    selectAppUser: "Por favor seleccione",
    yes: "Sí",
    no: "No",
    all: "Todos",
    selectAgentType: "Seleccionar Tipo de Agente",
    selectAgentTypePlaceholder: "Por favor seleccione",
    firstLevelAgent: "Agente de Primer Nivel",
    secondLevelAgent: "Agente de Segundo Nivel",
    agentAccount: "Por favor ingrese cuenta de agente",
    enterAgentAccount: "Por favor ingrese cuenta de agente",
    agentTag: "Etiqueta de Agente",
    selectAgentTag: "Por favor seleccione etiqueta de agente",
    query: "Consultar",
    report: "Informe",
    chart: "Gráfico",
    conversionRateChart: "Gráfico de Tasa de Conversión de Primer Depósito",
    depositAmountChart: "Gráfico de Monto de Depósito Acumulado",
    noDataForChart: "No hay datos de gráfico disponibles",
    selectTime: "Seleccionar Hora",
    queryFailed: "Consulta Fallida",
    exportSuccess: "Exportación Exitosa",
    exportFailed: "Exportación Fallida",
    items: "elementos",
    userStatistics: "Estadísticas de Registro y Conversión",
    table: "Tabla",
    dataTip: "Consejo de Datos",
    firstDepositCount: "Primeros Depósitos Activos",
    firstDepositRate: "Tasa Total de Conversión de Primer Depósito",
    coiledDepositCount: "Usuarios Retenidos",
    officialDirect: "Directo Oficial",
  },
  valueStatsReport: {
    "dateRangeExceeded": "El rango de fechas no puede exceder 31 días",
    title: "Informe de Estadísticas de Valor",
    dateRange: "Rango de Fechas",
    date: "Fecha",
    registerCount: "Cantidad de Registros",
    depositCount: "Cantidad de Depósitos",
    depositAmount: "Monto de Depósito",
    withdrawAmount: "Monto de Retiro",
    firstDayLtv: "LTV del Primer Día",
    thirdDayLtv: "LTV de 3 Días",
    seventhDayLtv: "LTV de 7 Días",
    fifteenthDayLtv: "LTV de 15 Días",
    thirtiethDayLtv: "LTV de 30 Días",
    fortyFifthDayLtv: "LTV de 45 Días",
    sixtiethDayLtv: "LTV de 60 Días",
    seventyFifthDayLtv: "LTV de 75 Días",
    ninetiethDayLtv: "LTV de 90 Días",
    oneHundredFifthDayLtv: "LTV de 105 Días",
    oneHundredTwentiethDayLtv: "LTV de 120 Días",
    oneHundredThirtyFifthDayLtv: "LTV de 135 Días",
    oneHundredFiftiethDayLtv: "LTV de 150 Días",
    dailyArppu: "ARPPU Diario",
    search: "Consultar",
    reset: "Restablecer",
    export: "Exportar",
    noData: "Sin Datos",
    isAppUser: "Por favor seleccione si es usuario de APP",
    selectAppUser: "Por favor seleccione",
    yes: "Sí",
    no: "No",
    all: "Todos",
    selectAgentType: "Seleccionar Tipo de Agente",
    selectAgentTypePlaceholder: "Por favor seleccione",
    firstLevelAgent: "Agente de Primer Nivel",
    secondLevelAgent: "Agente de Segundo Nivel",
    agentAccount: "Por favor ingrese cuenta de agente",
    enterAgentAccount: "Por favor ingrese cuenta de agente",
    agentTag: "Etiqueta de Agente",
    selectAgentTag: "Por favor seleccione etiqueta de agente",
    query: "Consultar",
    report: "Informe",
    chart: "Gráfico",
    selectTime: "Seleccionar Hora",
    queryFailed: "Consulta Fallida",
    exportSuccess: "Exportación Exitosa",
    exportFailed: "Exportación Fallida",
    selectCurrency: "Por favor seleccione moneda",
    items: "elementos",
    chartComingSoon: "Función de gráfico próximamente",
    officialDirect: "Directo Oficial"
  },
  keepStatsReport: {
    "modalDescription": "Estos datos indican, entre los usuarios registrados en la fecha indicada, la cantidad que realizó su primer depósito después del registro. Tasa de primer depósito activo = usuarios con primer depósito activo / usuarios registrados × 100%",
    "dateRangeExceeded": "El rango de fechas no puede exceder 31 días",
    "memberLoginCount": "Usuarios que Iniciaron Sesión",
    title: "Informe de Retención de Depósito",
    dateRange: "Rango de Fechas",
    date: "Fecha",
    day: "Fecha",
    registerCount: "Cantidad de Registros",
    firstDepositCount: "Cantidad de Registros de Primer Depósito",
    firstDepositRate: "Tasa de Primer Depósito Registrada",
    registerFirstDepositCount: "Cantidad de Registro de Primer Depósito",
    totalFirstDepositRate: "Tasa Total de Primer Depósito",
    activeFirstDepositCount: "Recuento de Primer Depósito Activo",
    activeFirstDepositRate: "Tasa de Primer Depósito Activo",
    coiledDepositCount: "Recuento de Redepósito Diario",
    coiledDepositRate: "Tasa de Redepósito del Mismo Día",
    firstDayRetention: "Depósito Continuo Día 1",
    firstDayRetentionTooltip: "Recuento/Tasa de Depósito Continuo Día 1",
    tomorrowKept: "Retención Día 2",
    tomorrowKeptTooltip: "Recuento/Tasa de Retención de Depósito Día 2",
    tomorrowKeptRate: "Tasa de Retención del Día Siguiente",
    threeKept: "Retención Día 3",
    threeKeptTooltip: "Recuento/Tasa de Retención de Depósito Día 3",
    threeKeptRate: "Tasa de Retención de 3 Días",
    fourKept: "Retención Día 4",
    fourKeptTooltip: "Recuento/Tasa de Retención de Depósito Día 4",
    fourKeptRate: "Tasa de Retención de 4 Días",
    fiveKept: "Retención Día 5",
    fiveKeptTooltip: "Recuento/Tasa de Retención de Depósito Día 5",
    fiveKeptRate: "Tasa de Retención de 5 Días",
    sixKept: "Retención Día 6",
    sixKeptTooltip: "Recuento/Tasa de Retención de Depósito Día 6",
    sixKeptRate: "Tasa de Retención de 6 Días",
    sevenKept: "Retención Día 7",
    sevenKeptTooltip: "Recuento/Tasa de Retención de Depósito Día 7",
    sevenKeptRate: "Tasa de Retención de 7 Días",
    fifteenKept: "Retención Día 15",
    fifteenKeptTooltip: "Recuento/Tasa de Retención de Depósito Día 15",
    fifteenKeptRate: "Tasa de Retención de 15 Días",
    thirtyKept: "Retención Día 30",
    thirtyKeptTooltip: "Recuento/Tasa de Retención de Depósito Día 30",
    thirtyKeptRate: "Tasa de Retención de 30 Días",
    thirtyCoiledDepositCount: "Recuento de Redepósito de 30 Días",
    thirtyCoiledDepositRate: "Tasa de Redepósito de 30 Días",
    dailyCoiledDepositRate: "Tasa de Redepósito Diario",
    thirtyCoiledDepositDetail: "Detalle de Redepósito de 30 Días",
    search: "Consultar",
    reset: "Restablecer",
    export: "Exportar",
    noData: "Sin Datos",
    isAppUser: "Seleccione si es usuario de APP",
    selectAppUser: "Por favor seleccione",
    yes: "Sí",
    no: "No",
    all: "Todos",
    selectAgentType: "Seleccionar Tipo de Agente",
    selectAgentTypePlaceholder: "Por favor seleccione",
    firstLevelAgent: "Agente de Primer Nivel",
    secondLevelAgent: "Agente de Segundo Nivel",
    agentAccount: "Ingrese cuenta de agente",
    enterAgentAccount: "Ingrese cuenta de agente",
    agentTag: "Etiqueta de Agente",
    selectAgentTag: "Seleccione etiqueta de agente",
    query: "Consultar",
    selectTime: "Seleccionar Hora",
    queryFailed: "Consulta Fallida",
    exportSuccess: "Exportación Exitosa",
    exportFailed: "Exportación Fallida",
    selectCurrency: "Seleccione moneda",
    items: "elementos",
    report: "Reporte",
    chart: "Gráfico",
    retentionChart: "Gráfico de Datos de Retención",
    noDataForChart: "No hay datos de gráfico disponibles",
    retentionCount: "Recuento de Retención",
    userStatistics: "Estadísticas de Retención",
    table: "Tabla",
    dataTip: "Consejo de Datos",
    officialDirect: "Directo Oficial"
  },
  betKeepStatsReport: {
    title: "Reporte de Retención de Apuestas",
    dateRange: "Rango de Fechas",
    day: "Fecha",
    registerCount: "Recuento de Registros",
    firstBetCount: "Recuento de Primera Apuesta Registrada",
    firstBetRate: "Tasa de Primera Apuesta Registrada",
    delayFirstBetCount: "Recuento de Primera Apuesta Activa",
    totalFirstBetRate: "Tasa Total de Primera Apuesta",
    activeFirstBetRate: "Tasa de Primera Apuesta Activa",
    thirtyRebetCount: "Recuento de Reapuesta de 30 Días",
    thirtyRebetCountTooltip: "Usuarios únicos que realizaron primera apuesta y volvieron a apostar dentro de 30 días",
    thirtyRebetRate: "Tasa de Reapuesta de 30 Días",
    thirtyRebetRateTooltip: "Recuento de Reapuesta de 30 Días / Recuento de Primera Apuesta Registrada",
    firstDayBet: "Reapuesta Día 1",
    firstDayBetTooltip: "Usuarios de primera apuesta D0 que reapostaron el mismo día",
    tomorrowBet: "Apuestas Día 2",
    tomorrowBetTooltip: "Usuarios de primera apuesta que apostaron al día siguiente de registrarse (D1)",
    threeBet: "Apuestas Día 3",
    threeBetTooltip: "Recuento/Tasa de Retención de Apuestas Día 3 (D2)",
    fourBet: "Apuestas Día 4",
    fourBetTooltip: "Recuento/Tasa de Retención de Apuestas Día 4 (D3)",
    fiveBet: "Apuestas Día 5",
    fiveBetTooltip: "Recuento/Tasa de Retención de Apuestas Día 5 (D4)",
    sixBet: "Apuestas Día 6",
    sixBetTooltip: "Recuento/Tasa de Retención de Apuestas Día 6 (D5)",
    sevenBet: "Apuestas Día 7",
    sevenBetTooltip: "Recuento/Tasa de Retención de Apuestas Día 7 (D6)",
    fifteenBet: "Apuestas Día 15",
    fifteenBetTooltip: "Recuento/Tasa de Retención de Apuestas Día 15 (D14)",
    thirtyBet: "Apuestas Día 30",
    thirtyBetTooltip: "Recuento/Tasa de Retención de Apuestas Día 30 (D29)",
    isAppUser: "Seleccione si es usuario de APP",
    selectAppUser: "Por favor seleccione",
    yes: "Sí",
    no: "No",
    all: "Todos",
    selectAgentType: "Seleccionar Tipo de Agente",
    selectAgentTypePlaceholder: "Por favor seleccione",
    agentAccount: "Cuenta de Agente",
    enterAgentAccount: "Ingrese cuenta de agente",
    agentTag: "Etiqueta de Agente",
    selectAgentTag: "Seleccione etiqueta de agente",
    query: "Consultar",
    export: "Exportar",
    reset: "Restablecer",
    noData: "Sin Datos",
    userStatistics: "Estadísticas de Retención de Apuestas",
    table: "Tabla",
    dateRangeExceeded: "El rango de fechas no puede exceder 31 días",
    officialDirect: "Directo Oficial",
    thirtyRebetDetail: "Detalle de Reapuesta de 30 Días"
  },
  delayFirstDeposit: {
    title: "Historial de Primer Depósito Retrasado",
    description: "Fecha de Registro",
    memberAccount: "Cuenta de Miembro",
    registerTime: "Hora de Registro",
    firstDepositTime: "Hora del Primer Depósito",
    firstDepositAmount: "Monto del Primer Depósito",
    agentAccount: "Cuenta de Agente",
  },
  overviewStatsReport: {
    "dateRangeExceeded": "El rango de fechas no puede exceder 31 días",
    title: "Reporte General",
    summary: "Estadísticas Generales",
    dateRange: "Rango de Fechas",
    date: "Fecha",
    day: "Fecha",
    loginCount: "Recuento de Inicios de Sesión",
    registerCount: "Recuento de Registros",
    memberLoginCount: "Recuento de Inicios de Sesión de Miembro",
    firstDepositCount: "Recuento del Primer Depósito",
    firstDepositRate: "Tasa del Primer Depósito",
    depositAmount: "Monto Total de Depósito",
    withdrawAmount: "Monto Total de Retiro",
    profitAndLoss: "P&L de Depósito/Retiro",
    registerFirstDepositCount: "Primer Depósito Registrado",
    activeFirstDepositCount: "Primer Depósito Activo",
    registerFirstDepositRate: "Tasa de Primer Depósito Registrada",
    totalFirstDepositRate: "Tasa Total de Primer Depósito",
    tomorrowRetention: "Retención del Día Siguiente",
    sevenDayRetention: "Retención de 7 Días",
    thirtyDayRetention: "Retención de 30 Días",
    firstDayLTV: "LTV (Primer Día)",
    thirtyDayLTV: "LTV (30 Días)",
    search: "Buscar",
    reset: "Restablecer",
    report: "Reporte",
    chart: "Gráfico",
    overviewChart: "Gráfico de Datos Generales",
    noDataForChart: "No hay datos de gráfico disponibles",
    queryFailed: "Consulta Fallida",
    noData: "Sin Datos",
    items: "elementos",
    export: "Exportar",
    exportSuccess: "Exportación Exitosa",
    exportFailed: "Exportación Fallida",
    isAppUser: "Seleccione si es usuario de APP",
    selectAppUser: "Por favor seleccione",
    yes: "Sí",
    no: "No",
    all: "Todos",
    selectAgentType: "Seleccionar Tipo de Agente",
    selectAgentTypePlaceholder: "Por favor seleccione",
    firstLevelAgent: "Agente de Primer Nivel",
    secondLevelAgent: "Agente de Segundo Nivel",
    agentAccount: "Ingrese cuenta de agente",
    enterAgentAccount: "Ingrese cuenta de agente",
    agentTag: "Etiqueta de Agente",
    selectAgentTag: "Seleccione etiqueta de agente",
    query: "Consultar",
    selectTime: "Seleccionar hora",
    selectCurrency: "Seleccione moneda",
    userStatistics: "Estadísticas Generales",
    table: "Tabla",
    dataTip: "Consejo de Datos",
    officialDirect: "Directo Oficial"
  },
  memberLoginLogReport: {
    title: "Reporte de Registro de Inicio de Sesión de Miembro",
    dateRange: "Hora de Inicio de Sesión",
    date: "Fecha",
    day: "Fecha",
    registerCount: "Recuento de Registros",
    depositCount: "Recuento de Depósitos",
    loginIp: "IP de Inicio de Sesión",
    loginDeviceId: "ID de Dispositivo de Inicio de Sesión",
    ipLocation: "Ubicación de IP",
    loginMethod: "Método de Inicio de Sesión",
    loginChannel: "Canal de Inicio de Sesión",
    memberAccount: "Cuenta de Miembro",
    enterMemberAccount: "Ingrese cuenta de miembro",
    enterLoginIp: "Ingrese IP de inicio de sesión",
    enterIpLocation: "Ingrese ubicación de IP",
    enterLoginMethod: "Ingrese método de inicio de sesión",
    enterLoginChannel: "Ingrese canal de inicio de sesión",
    all: "Todos",
    loginDomain: "Dominio de Inicio de Sesión",
    unknownLocation: "Desconocido",
    loginChannels: {
      all: "Todos",
      others: "Otros",
      web: "Web",
      androidApp: "APP Android",
      androidH5: "Android H5",
      androidPwa: "Android PWA",
      iosH5: "iOS H5",
      iosPwa: "iOS PWA",
      iosApp: "APP iOS"
    },
    loginMethods: {
      all: "Todos",
      password: "Usuario/Contraseña",
      facebook: "Facebook",
      google: "Google",
      apple: "Apple"
    },
  },
  memberLoginLogSummary: {
    title: "Resumen de Registro de Inicio de Sesión de Miembro",
    dateRange: "Rango de Fechas",
    date: "Fecha",
    day: "Fecha",
    registerCount: "Recuento de Registros",
    depositCount: "Recuento de Depósitos",
  },
  onlineUserPanel: {
    title: "Panel de Usuario En Línea",
    currentOnlineUsers: "Usuarios En Línea Actual",
    currentOnlineUsersDesc: "Las estadísticas incluyen: usuarios que han iniciado sesión, ingresado a la página del juego, ingresado a la página de depósito/retiro, o realizado acciones en el centro personal dentro de los últimos 30 minutos",
    realtimeOnlineChart: "Usuarios En Línea en Tiempo Real (Comparación de tres días para el mismo período)",
    mobileProviderDistribution: "Distribución del Operador",
    deviceDistribution: "Distribución de Dispositivos",
    regionDistribution: "Distribución Regional",
    regionList: "Distribución Regional",
    onlineUserList: "Lista de Usuarios En Línea",
    labels: {
      unknown: "Desconocido",
      noData: "Sin datos",
      noCityData: "Sin datos de ciudad",
    },
    actionTypes: {
      login: "Inicio de sesión",
      logout: "Cierre de sesión",
      enterGame: "Entrada al juego",
      depositPage: "Página de depósito",
      withdrawPage: "Página de retiro",
      personalCenter: "Centro personal",
    },
    regionTable: {
      country: "País",
      province: "Provincia",
      city: "Ciudad",
      total: "Usuarios",
      all: "Todos",
    },
    table: {
      memberAccount: "Cuenta de Miembro",
      lastActionTime: "Hora de Última Actividad",
      actionType: "Tipo de Actividad",
      deviceType: "Tipo de Dispositivo",
      totalRecords: "Actualmente {total} registros",
    },
  },
  payOrderStat: {
    title: "Panel de Recarga",
    selectCurrency: "Seleccionar Moneda",
    orderOverview: "Descripción General del Pedido",
    rechargeAmount: "Monto de Recarga",
    withdrawAmount: "Monto de Retiro",
    payWithdrawDiff: "Diferencia de Recarga-Retiro",
    statistics: "Estadísticas",
    totalPayCount: "Recuento Total de Recarga",
    successRate: "Tasa de Éxito de Recarga",
    avgPayTime: "Tiempo Promedio de Llegada de Recarga",
    successCount: "Recarga Exitosa",
    failedCount: "Recarga Fallida",
    pendingCount: "Pendiente",
    channelTitle: "Método de Recarga",
    selectChannel: "Seleccionar Método de Recarga",
    channelTotalPayCount: "Recuento Total de Recarga",
    channelAvgPayTime: "Tiempo Promedio de Llegada de Recarga",
    channelSuccessCount: "Recarga Exitosa",
    channelFailedCount: "Recarga Fallida",
    channelPendingCount: "Pendiente",
    fetchFailed: "Error al obtener estadísticas del panel de recarga",
    channelFetchFailed: "Error al obtener estadísticas del panel de método de recarga",
  },
  withdrawOrderStat: {
    title: "Panel de Retiro",
    selectCurrency: "Seleccionar Moneda",
    orderOverview: "Descripción General del Pedido",
    rechargeAmount: "Monto de Recarga",
    withdrawAmount: "Monto de Retiro",
    payWithdrawDiff: "Diferencia de Recarga-Retiro",
    statistics: "Estadísticas",
    totalWithdrawCount: "Recuento Total de Retiros",
    successRate: "Tasa de Éxito de Retiro",
    avgWithdrawTime: "Tiempo Promedio de Retiro",
    avgRiskCheckTime: "Tiempo Promedio de Revisión",
    avgRiskCheckTimeTooltip: "Órdenes de Revisión Manual",
    successCount: "Desembolsado",
    refusedCount: "Rechazado",
    pendingPayoutCount: "Desembolso Pendiente",
    pendingReviewCount: "Revisión Pendiente",
    pendingReviewCountTooltip: "Órdenes de Revisión Manual",
    channelTitle: "Método de Retiro",
    selectChannel: "Seleccionar Método de Retiro",
    channelTotalWithdrawCount: "Recuento Total de Retiros",
    channelAvgWithdrawTime: "Tiempo Promedio de Retiro",
    channelAvgRiskCheckTime: "Tiempo Promedio de Revisión",
    channelSuccessCount: "Desembolsado",
    channelRefusedCount: "Rechazado",
    channelPendingPayoutCount: "Desembolso Pendiente",
    channelPendingReviewCount: "Revisión Pendiente",
    fetchFailed: "Error al obtener estadísticas del panel de retiro",
    channelFetchFailed: "Error al obtener estadísticas del panel de método de retiro",
  },
  crossDayTransferSettlement: {
    title: "Panel de Análisis de Liquidación de Transferencia Entre Días",
    keyIndicators: "Indicadores Clave",
    selectDate: "Seleccionar Fecha y Hora",
    yesterdayUnsettledCount: "Recuento de Apuestas No Liquidadas de Ayer",
    todayCompletedTransferCount: "Liquidación de Transferencia Completada Hoy",
    todayRemainingUnsettledCount: "Apuestas No Liquidadas de Ayer Restantes Hoy",
    todaySecondSettlementCount: "Apuestas de Transferencia Hoy con Segunda Liquidación",
    profitLossChange: "Cambio de Ganancia/Pérdida (Reliquidación)",
    repeatSettlementRatio: "Razón de Reliquidación",
  },
  jeepneyFunnelAnalysis: {
    title: "Análisis de Embudo Jeepney",
    statisticsDate: "Fecha de Estadísticas",
    dateSelect: "Seleccionar Fecha",
    fixedForToday: "Fijado para el día",
    dateRange: "Rango de Fechas",
    funnelChart: "Gráfico de Embudo",
    funnelTable: "Tabla de Embudo (Por Cadena de Eventos)",
    metricCards: "Tarjetas de Métricas",
    step: "Paso",
    event: "Evento",
    userCountUV: "Usuarios (UV)",
    dimension: "Dimensión",
    enterActivity: "Ingresar a Página Principal de Actividad",
    clickAdvance: "Haz Clic en Avance (Al Menos 1 Vez)",
    insufficientCurrency: "Activar Bloque de Moneda Insuficiente (Al Menos 1 Vez)",
    openCurrencyPopup: "Abrir Ventana Emergente de Adquirir Moneda (Al Menos 1 Vez)",
    completeCurrencyAcquire: "Completar Adquisición de Moneda (Al Menos 1 Vez)",
    reachFinalStage: "Alcanzar Etapa Final",
    settlementSuccess: "Liquidación Exitosa",
    settlementFailure: "Liquidación Fallida",
    settlementResult: "Resultado de Liquidación (Éxito/Fallo)",
    activityParticipation: "Participación en Actividad",
    rechargeUsers: "Usuarios de Recarga",
    exchangeUsers: "Usuarios de Intercambio",
    inviteValidFriends: "Amigos Válidos Invitados",
    conversionRate: "Tasa de Conversión",
    noData: "Sin Datos"
  }
};
